export default "__VITE_ASSET__B2L92Cfw__"